<template>
  <div class="public-nav">
    <b-navbar toggleable="lg" type="dark" variant="primary">
      <b-navbar-brand to="/login">{{$t('appName')}}</b-navbar-brand>

      <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

      <b-collapse id="nav-collapse" is-nav>
        <!-- Right aligned nav items -->
        <b-navbar-nav class="ml-auto">
          <b-nav-item to="/login" active-class="active">{{$t('publicNav.login')}}</b-nav-item>
          <b-nav-item to="/register" active-class="active">{{$t('publicNav.register')}}</b-nav-item>
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>
  </div>
</template>

<script>
  export default {};
</script>
